import { FormControl, OutlinedInput } from "@material-ui/core";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { update_item_menu_setup } from "../../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import { NewInputText } from "../../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import {
  ReusableOnboardingButton,
  ReusableOnboardingMapButton,
} from "../../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TopTextReusableComponent } from "../../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import SuggestNewButton from "../../../../../../reusableOnboardingPopupComponent/suggestNew/SuggestNewButton";
import { ToggleButtonWithYesNo } from "../../../../AllButton/ToggleButtonReuse";

const validate = (values) => {
  const errors = {};
  if (
    values.allergy_information.value &&
    values.allergy_information.allergy_tag.length === 0
  ) {
    errors.allergy_tag = "Please select tag";
  }

  if (
    values.allergy_information.value &&
    values.allergy_information.allergy_tag.length > 0 &&
    values.primary_allergy.length === 0
  ) {
    errors.primary_allergy = "Please select primary allergy";
  }
  return errors;
};

const Allergy = (props) => {
  const back = () => {
    props.onChange(3);
    window.scroll(0, 0);
  };

  const onClickBack = () => {
    let formData = {};
    const token = props.auth.user.accessToken;
    formData.currentState = 2;
    formData.runingTrack = 3;
    props.update_item_menu_setup(props.activeItemId, formData, token, back);
  };

  const [allergyInfo, setAllergyInfo] = useState([]);

  const onChangeAllergyInfo = () => {
    formik.setFieldValue(
      "allergy_information.value",
      !formik.values.allergy_information.value
    );
  };

  const setPrimaryAlergy = (itemName) => {
    formik.setFieldValue("primary_allergy", itemName);
  };

  const onClickAddAlergy = (itemName) => {
    let data = formik.values.allergy_information.allergy_tag;

    if (data.includes(itemName)) {
      alert("Item already added");
    } else {
      data.push(itemName);
    }

    formik.setFieldValue("allergy_information.allergy_tag", data);
  };

  const removeAlergy = (itemName) => {
    if (formik.values.primary_allergy.length > 0) {
      if (formik.values.primary_allergy === itemName) {
        formik.setFieldValue("primary_allergy", "");
      }
    }

    let data = formik.values.allergy_information.allergy_tag;
    data = data.filter((item) => {
      return item !== itemName;
    });

    formik.setFieldValue("allergy_information.allergy_tag", data);
  };
  const [count, setCount] = useState(1);

  const onClickNext = (e) => {
    e.preventDefault();
    setCount(count + 1);
    formik.handleSubmit();
  };

  const onSuccess = () => {
    props.onChange(5);
    window.scroll(0, 0);
  };

  const formik = useFormik({
    initialValues: {
      allergy_information: {
        value: false,
        allergy_tag: [],
        allergy_text: "",
      },
      primary_allergy: "",
    },
    validate,
    enableReinitialize: true,
    onSubmit: (values) => {
      let formData = {};
      formData = { ...formik.values };
      const token = props.auth.user.accessToken;
      formData.currentState = 4;
      formData.runingTrack = 5;
      props.update_item_menu_setup(
        props.activeItemId,
        formData,
        token,
        onSuccess
      );
    },
  });

  useEffect(() => {
    let data = [];
    for (let i = 0; i < props.allergy_info.length; i++) {
      if (props.allergy_info[i].status === "APPROVED") {
        data.push({
          title: props.allergy_info[i].title,
          icon: props.allergy_info[i].icon,
        });
      }
    }
    setAllergyInfo(data);
  }, [props.allergy_info]);

  useEffect(() => {
    if (Object.entries(props.menuCategoryItems).length !== 0) {
      let data = props.menuCategoryItems;
      if (
        data &&
        data.allergy_information &&
        data.allergy_information.allergy_tag
      ) {
        formik.setFieldValue(
          "allergy_information.allergy_tag",
          data.allergy_information.allergy_tag
        );
      }
      if (data && data.allergy_information && data.allergy_information.value) {
        formik.setFieldValue(
          "allergy_information.value",
          data.allergy_information.value
        );
      }

      if (
        data &&
        data.allergy_information &&
        data.allergy_information.allergy_text
      ) {
        formik.setFieldValue(
          "allergy_information.allergy_text",
          data.allergy_information.allergy_text
        );
      }
      if (data && data.primary_allergy) {
        formik.setFieldValue("primary_allergy", data.primary_allergy);
      }
    }
  }, [props.menuCategoryItems]);

  return (
    <React.Fragment>
      <Form>
        <div className="mb-4">
          <TopTextReusableComponent
            headingText="New Item"
            headingParagraph="Manage your food items"
          />
        </div>
        <div className="bg-gray px-3 py-2">
          <Row>
            <Col md={6}>
              <div className="d-flex align-items-center">
                <div className="f12-700 pr-3" style={{ width: 140 }}>
                  Ext Item ID :
                </div>
                <FormControl className={"w-100 bg-white"} variant="outlined">
                  <OutlinedInput
                    disabled
                    value={
                      props.menuCategoryItems && props.menuCategoryItems.ext_id
                    }
                  />
                </FormControl>
              </div>
            </Col>
          </Row>
        </div>
        <div
          className="displayItemsName f11-400 enRadius5 my-4"
          style={{ height: 50 }}
        >
          {props.menuCategoryItems && props.menuCategoryItems.name}
        </div>
        <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
          <div className="f14-700 col-8 col-md-8 col-lg-6 p-0">
            Allergy Information
          </div>
          <div className="col-4 col-md-4 col-lg-6">
            <ToggleButtonWithYesNo
              checkedBox={formik.values.allergy_information.value}
              onChange={() => onChangeAllergyInfo()}
            />
          </div>
        </div>
        {formik.values.allergy_information.value ? (
          <>
            <div className="restaurant_type_onboarding_main small">
              <div className="cuisine-main mt-0">
                <div
                  className={
                    // state.all_food_type.length > 8
                    //   ?
                    "cuisine-main-padding-border"
                    //   : ""
                  }
                >
                  <div
                    id="box-style"
                    className="cuisine-main-padding"
                    style={{ display: "flex", flexWrap: "wrap" }}
                  >
                    {allergyInfo.map((icon, index) => (
                      <ReusableOnboardingMapButton
                        key={index}
                        // classsection={
                        //   state.selected_food_type.includes(icon)
                        //     ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type "
                        //     : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                        // }
                        classsection="onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                        src={icon.icon}
                        title={icon.title}
                        //   onClick={onRestaurantFoodTypeArraySelector(
                        //     icon,
                        //     index
                        //   )}

                        onClick={() => onClickAddAlergy(icon.title)}
                      />
                    ))}
                    {/* <AddButtonIconComponent
                  buttonText="Suggest New"
                  fontIcon="fa fa-plus"
                  colorCss="red"
                /> */}
                  </div>
                  {formik.errors.allergy_tag &&
                  formik.touched &&
                  formik.touched.allergy_information &&
                  formik.touched.allergy_information.allergy_tag ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.allergy_tag}
                    </div>
                  ) : null}
                </div>

                <div className="suggest-button-heading">
                  <SuggestNewButton categoryId={"5f59f5d4471b85440d5adccc"} />
                </div>

                <div className="f14-700 mt-4">
                  Out of the selections below, which one is primary?
                </div>
                <div className="f12-400 mb-3 opacity5">
                  Select only one of the options below as a default - this is
                  shown to the user .
                </div>
                <div
                  className="cuisine-main-padding-bottom mobile-device-bottom-margin mt-4"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  {formik.values.allergy_information.allergy_tag.map(
                    (icon, index) => (
                      <ReusableOnboardingMapButton
                        key={index}
                        classsection={
                          formik.values.primary_allergy === icon
                            ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_two onboarding_mapbutton_reusable_type"
                            : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_active"
                        }
                        src={icon.icon}
                        title={icon}
                        onClick={() => setPrimaryAlergy(icon)}
                        displayPrimary={
                          formik.values.primary_allergy === icon ? true : false
                        }
                        displayRemove={true}
                        removeButtonClick={() => removeAlergy(icon)}
                      />
                    )
                  )}
                </div>
                {formik.errors.primary_allergy &&
                formik.touched.primary_allergy ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.primary_allergy}
                  </div>
                ) : null}
              </div>
            </div>

            <div className="f12-400 mb-4 opacity5">
              List the ingredients in this item, any allergic item from above
              present in the dish. Put the information as per your best
              knowledge Let the users know if the dish could be made without the
              Allergic ingredient or not.
            </div>
            <Row>
              <Col md={10}>
                <NewInputText
                  labelText="Additional Text"
                  extraClass="mb-4 w-100"
                  multiline={true}
                  rows="5"
                  value={formik.values.allergy_information.allergy_text}
                  onChange={formik.handleChange}
                  name="allergy_information.allergy_text"
                />
              </Col>
            </Row>
          </>
        ) : (
          <> </>
        )}
        <div className="onboarding-map-setup-screen-autodetect-button mt-5">
          <ReusableOnboardingButton
            buttonTitle="Back Button"
            buttonClass="btn-lg btn btn-outline-secondary"
            buttonText="Back"
            buttonType="button"
            onClick={() => onClickBack()}
          />
          <ReusableOnboardingButton
            buttonTitle="Next Button"
            buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
            buttonText="Save and Next"
            buttonType="button"
            //onClick={onSubmit}
            onClick={(e) => onClickNext(e)}
          />
        </div>
      </Form>
    </React.Fragment>
  );
};

Allergy.propTypes = {
  auth: PropTypes.object.isRequired,
  update_item_menu_setup: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  allergy_info: state.category.allergy_info,
  menuCategoryItems: state.onboarding.menuCategoryItems,
  activeItemId: state.onboarding.activeItemId,
});

export default connect(mapStateToProps, { update_item_menu_setup })(Allergy);
